/**
 * Catálogo de códigos de error del sistema.
 *
 * El CÓDIGO es el contrato entre la base de datos y la interfaz. El mensaje no: se
 * puede reescribir sin romper nada. Si el texto del RAISE fuera el contrato, no se
 * podría corregir una redacción sin tocar la pantalla.
 *
 * Todo mensaje dice la CAUSA y la SALIDA. Un bloqueo que solo dice que falló deja al
 * operario atrapado a las tres de la mañana.
 */
const MENSAJES = {
  E_NO_AUTENTICADO: 'La sesión venció. Volver a ingresar.',
  E_ROL_NO_AUTORIZADO: 'Este rol no tiene permiso para esta acción. Pedirlo a quien corresponda.',
  E_CUENTA_BLOQUEADA: 'La cuenta está bloqueada por intentos fallidos. Solo el administrador la desbloquea.',
  E_CUENTA_INACTIVA: 'La cuenta está inactiva. Pedirle al administrador que la reactive.',
  E_DEBE_CAMBIAR_PASSWORD: 'Hay que definir una contraseña nueva antes de seguir.',
  E_CREDENCIALES_INVALIDAS: 'El documento o la contraseña no coinciden. Revisar los datos.',
  E_MINIMO_DOS_ADMINISTRADORES:
    'El sistema tiene que conservar al menos dos administradores activos. Nombrar otro antes de desactivar este.',
  // Los tres del super administrador, feature 36, 2026-09-29.
  E_SOLO_SUPER_ADMINISTRADOR:
    'Esto lo hace solo el super administrador, que es el dueño o un socio de la sociedad.',
  E_ULTIMO_SUPER_ADMINISTRADOR:
    'Es el único super administrador. Nombrar a otro antes de quitarse la marca.',
  E_SUPER_ADMINISTRADOR_NO_ADMIN:
    'Solo un administrador activo puede ser super administrador.',
  // El permiso para corregir una noche, adjudicación 266, 2026-10-01.
  E_SOLICITUD_PENDIENTE:
    'Ya hay un pedido de permiso para esa noche. Esperar a que el super administrador responda.',
  E_SOLICITUD_YA_DECIDIDA: 'Ese pedido ya se respondió. Refrescar la lista.',
  E_SOLICITUD_NO_EXISTE: 'No existe ese pedido de permiso. Refrescar la lista.',
  E_USUARIO_NO_BLOQUEADO: 'Esa cuenta no está bloqueada, así que no hay nada que desbloquear.',
  E_USUARIO_NO_EXISTE: 'No existe un usuario con ese identificador. Refrescar la lista.',
  E_PASSWORD_INVALIDA:
    'La contraseña nueva no cumple el mínimo: diez caracteres, con una letra y un número.',
  E_SOLICITUD_INVALIDA:
    'Hay un dato mal escrito en el formulario. Revisar el documento, el nombre, el rol y la sede.',
  E_SIN_CONEXION: 'No hay conexión con el servidor. Revisar el internet y volver a intentar.',
  // Para lo que el servidor devuelve sin un código del contrato. Existe para que la
  // interfaz tenga adónde caer sin poner en pantalla el texto crudo de Postgres: un
  // «permission denied for table usuario» no le dice nada al operario y sí le dice algo
  // a quien no debería. El mensaje original va a la consola.
  E_DESCONOCIDO:
    'La aplicación no reconoce el error que devolvió el servidor. Avisar al administrador y contarle qué se estaba haciendo.',
  E_JORNADA_ABIERTA_EXISTE: 'Ya hay una jornada abierta. Cerrarla antes de abrir otra.',
  E_JORNADA_NO_ABIERTA: 'La jornada no está abierta, así que no admite registros nuevos.',
  E_JORNADA_EN_CORRECCION_EXISTE: 'Ya hay una jornada en corrección. Cerrarla antes de reabrir otra.',
  // Nace en la tarea 9 de la fase 5 y no reusa ninguno de los dos códigos que tenía cerca.
  // E_ASIENTO_NO_PERMITIDO manda a revisar la dirección del movimiento entre las cuentas, y acá
  // las cuentas están bien: lo que pasa es que la noche está en corrección. Y E_JORNADA_NO_ABIERTA
  // dice "no admite registros nuevos" a secas, que es falso: en corrección sí entran correcciones
  // y anulaciones, y el remedio no es abrir la jornada sino terminar la corrección.
  //
  // LA SEGUNDA MITAD CAMBIÓ EN LA TAREA 12, y era una instrucción equivocada. Decía "terminá la
  // corrección y volvé a cerrarla", y desde que `app.cerrar_jornada` rechaza una jornada en
  // corrección este código también le sale a quien acaba de intentar cerrarla: mandarlo a
  // cerrarla otra vez lo deja dando vueltas. `traducirError` no lee el `detail` que manda la base,
  // así que este texto es todo lo que ve la pantalla y tiene que servir para los dos casos.
  E_JORNADA_EN_CORRECCION:
    'Esa jornada está en corrección: admite correcciones y anulaciones, no registros nuevos. Y se vuelve a cerrar desde el recierre, no desde el cierre normal.',
  E_EFECTIVO_DE_LA_NOCHE_YA_SALIO:
    'Ese día ya se pagó algo con el efectivo de la noche: propinas o una reposición de caja menor. Anular esos pagos primero y después descartar la noche.',
  E_JORNADA_CERRADA_NO_SE_DESCARTA:
    'Esa noche ya se cerró. Para descartarla, reabrirla primero y después descartarla desde la corrección.',
  E_REINICIO_CON_REGISTROS:
    'Ya hay egresos, compras, nómina u otros registros reales. El reinicio sólo sirve antes de empezar a operar.',
  E_JORNADA_FECHA_FUTURA: 'La fecha de la jornada no puede ser futura. Elegir hoy o un día anterior.',
  E_JORNADA_FECHA_DUPLICADA: 'Ya existe una jornada para esa fecha. Abrir la que está o corregir la fecha.',
  E_JORNADA_SIN_MONTOS:
    'No se puede cerrar la jornada sin registrar al menos un monto. Si esa noche no hubo ventas, declararlo en Ventas y cover.',
  E_JORNADA_CON_MONTOS: 'Esa noche ya tiene ventas, cover o propinas registradas, así que no se puede declarar sin ventas.',
  E_DIA_SIN_APERTURA: 'Ese día el bar no abre. Si de todas formas se va a abrir, la dirección lo habilita en Días de apertura.',
  E_DIA_INVALIDO: 'Elegir los días entre lunes y domingo.',
  E_PERIODO_CERRADO: 'El periodo está cerrado y no admite registros. Pedirle al administrador que lo reabra.',
  // Los dos de acá abajo nacen en la tarea 18 de la fase 5, y nacen juntos porque son el mismo
  // defecto de un lado y del otro. El mensaje de E_PERIODO_CERRADO está escrito para quien intentó
  // REGISTRAR algo en un mes cerrado, y lo manda a pedir la reapertura. Dicho al contador que acaba
  // de pedir cerrar un mes que ya estaba cerrado, le habla de un registro que no hizo y le ofrece
  // una salida que no quiere. Lo mismo con E_PERIODO_ABIERTO, que manda a anular un asiento, dicho
  // al administrador que pidió reabrir un mes que ya estaba abierto. En los dos casos no hay nada
  // que hacer, y eso es lo único que el mensaje tiene que decir.
  //
  // El nombre sigue la convención de la casa para «pediste una transición que ya pasó»:
  // E_YA_ANULADO, E_COMPRA_YA_VALIDADA, E_REPARTO_YA_CONFIRMADO, E_REPARTO_YA_PAGADO.
  E_PERIODO_YA_CERRADO:
    'Ese mes ya estaba cerrado. No hace falta cerrarlo de nuevo. Refrescar la pantalla para ver el estado real.',
  E_PERIODO_YA_ABIERTO:
    'Ese mes ya está abierto, así que no hay nada que reabrir. Refrescar la pantalla para ver el estado real.',
  E_PERIODO_ANTERIOR_ABIERTO: 'Cerrar primero el mes anterior. No se pueden cerrar meses con huecos.',
  E_PERIODO_POSTERIOR_CERRADO: 'Reabrir primero los meses posteriores a este.',
  E_DESGLOSE_NO_CUADRA: 'El desglose por medio de pago no suma el neto. Revisar los montos digitados.',
  // Entra con la tarea 13 de la fase 6, que es la primera que lo levanta; estaba en el catálogo
  // del contrato desde la tarea 1 y sin frase. Va pegado al de arriba porque los dos dicen «no
  // cuadra» y hay que poder distinguirlos de un vistazo: aquél es el desglose por medio de pago
  // del cierre de la noche y este es el comprobante del adquirente, que son dos pantallas
  // distintas y dos documentos distintos. Un mensaje prestado manda a revisar lo que no es.
  E_CONSIGNACION_NO_CUADRA:
    'Lo consignado más la comisión y las dos retenciones tiene que sumar el bruto vendido con tarjeta. Revisar el comprobante del adquirente.',
  E_DESCUENTO_EXCEDE_BRUTO: 'El descuento es mayor que la venta bruta. Revisar los dos valores.',
  E_MONTO_NEGATIVO: 'El monto no puede ser negativo. Corregir el valor.',
  // Tarea 21 de la fase 12: más de 1.000 pesos entre el extracto y el libro no es redondeo.
  E_AJUSTE_AL_PESO_EXCEDE:
    'El extracto y el banco del sistema difieren en más de $ 1.000. Eso no es redondeo: falta registrar un movimiento del banco.',
  // Los dos primeros de los ocho códigos que la fase 6 trajo al contrato maestro. Entran
  // acá en la tarea 2 y no antes porque es la primera que los levanta: el dominio los usa
  // para rechazar lo mismo que rechaza `app.assert_comision_en_rango` y
  // `app.precio_publicado_cop`, para que la calculadora no publique un precio que el
  // servidor después va a devolver con error.
  E_COMISION_FUERA_DE_RANGO:
    'La comisión de la plataforma tiene que estar entre 0 y 89,99 por ciento. Revisar el valor digitado.',
  E_PRECIO_CARTA_FALTANTE:
    'El producto no tiene precio de carta, así que no se puede calcular el precio a publicar. Ponerle precio primero.',
  // Los que levanta la tarea 3, que crea `plataforma` y `plataforma_comision`.
  // `E_PLATAFORMA_YA_EXISTE` es el noveno código de la fase y no estaba en la lista de la tarea 1:
  // sin él, dar de alta dos veces la misma plataforma devolvía el 23505 crudo de Postgres, que es
  // justo lo que la cabecera de este archivo describe como el defecto a evitar.
  E_PLATAFORMA_NO_EXISTE: 'No existe esa plataforma de domicilios. Refrescar la lista.',
  // La fase 7 es la primera que lo usa, así que es la que le escribe la frase. Va junto a
  // E_PLATAFORMA_NO_EXISTE y E_CARGO_NO_EXISTE, que son su misma familia: algo que se eligió
  // de una lista y ya no está. No se reusa E_DOCUMENTO_DUPLICADO, que es lo que pedía el plan
  // de fase: un no encontrado no es un duplicado, y la pantalla le diría al usuario que ya
  // existe justo lo que no existe.
  E_PROVEEDOR_NO_EXISTE: 'No existe ese proveedor. Refrescar el directorio.',
  // Entra con la tarea 18 de la fase 6, que es la primera pantalla que lo puede mostrar. Lo
  // levantan dos funciones desde la tarea 3, y hasta acá quien lo recibía leía el código crudo.
  // No reusa E_SOLICITUD_INVALIDA: la salida no es corregir el dato sino elegir otro producto,
  // porque un insumo no se vende y no hay forma de arreglarlo desde ese formulario.
  E_ITEM_NO_VENDIBLE: 'Ese producto es un insumo y no se vende por plataforma. Elegir uno vendible.',
  E_PLATAFORMA_YA_EXISTE:
    'Ya hay una plataforma con ese código. Usar otro código o editar la que ya está.',
  E_COMISION_SIN_VIGENCIA:
    'La plataforma no tiene comisión configurada para esa fecha. Cargarla antes de registrar pedidos de ese día.',
  // Nace acá aunque el contrato lo traiga de la fase 7, porque la fase 6 es la primera en usarlo:
  // un rango de vigencia que pisa a otro del mismo sujeto. La fase 7 lo reusa para la
  // reclasificación de categoría. Adjudicación 24 aplicada a un código en vez de a una tabla.
  E_VIGENCIA_SOLAPADA:
    'Ese rango de vigencia se cruza con uno que ya existe. Elegir otra fecha de inicio.',
  E_SALDO_INSUFICIENTE: 'La cuenta no tiene saldo suficiente. Reponer el fondo o usar otro medio de pago.',
  E_EXCEDE_FONDO_FIJO: 'La caja menor superaría su fondo fijo. Reponer menos.',
  E_EFECTIVO_NO_CUBRE_PROPINAS: 'El efectivo contado no alcanza para las propinas de la noche.',
  E_MOTIVO_REQUERIDO: 'Escribir el motivo, con diez caracteres como mínimo.',
  // Existe en SQL desde la fase 3 y en la lista de códigos del maestro, y hasta la tarea 8 de la
  // fase 6 no tenía frase acá: quien se equivocaba de código de cuenta leía el código crudo. La
  // frase manda a mirar el catálogo, que es donde está la respuesta, y no a reintentar.
  E_CUENTA_NO_EXISTE: 'No hay ninguna cuenta con ese código. Revisar el catálogo de cuentas.',
  E_YA_CONTRARRESTADO:
    'Ese asiento ya tiene su contraasiento. Otro lo reversaría dos veces.',
  E_YA_ANULADO: 'El movimiento ya estaba anulado. No hace falta anularlo de nuevo.',
  // Los dos entran con la tarea 10 de la fase 6. `E_PEDIDO_YA_CANCELADO` estaba en el catálogo
  // del contrato desde la tarea 1 y sin frase; `E_PEDIDO_NO_EXISTE` entra al catálogo con esa
  // misma tarea, porque el plan traía `PEDIDO_NO_EXISTE` con P0002, que es la forma que el maestro
  // ya había corregido una vez con `E_REPARTO_NO_EXISTE`.
  //
  // No reusan `E_YA_ANULADO`: ese habla del movimiento, y quien cancela un pedido de plataforma no
  // sabe que hay un asiento debajo. El código es el contrato y la frase es lo que se lee.
  E_PEDIDO_YA_CANCELADO: 'Ese pedido ya estaba cancelado. Cancelarlo otra vez devolvería el dinero dos veces.',
  E_PEDIDO_NO_EXISTE: 'No hay ningún pedido de plataforma con ese identificador.',
  // Entra con la tarea 11 de la fase 6, y al catálogo del contrato con ella: el plan traía
  // `P0002` con `CONSIGNACION_NO_EXISTE` sin prefijo, séptima vez.
  E_CONSIGNACION_NO_EXISTE: 'No hay ninguna consignación de plataforma con ese identificador.',
  E_ASIENTO_NO_PERMITIDO: 'Ese asiento no es válido: revisar la dirección del movimiento entre las cuentas.',
  // Nace en la tarea 4 de la fase 5, y nace por lo que el mensaje de arriba dice. El plan pedía
  // que la guarda del origen reusara E_ASIENTO_NO_PERMITIDO, y con ese código quien intenta
  // anular el traslado al ahorro lee que revise la dirección del movimiento entre las cuentas:
  // una instrucción correcta para el caso que motivó ese código y sin relación con este. Una
  // guarda que manda a revisar lo que no es el problema no sirve más que ninguna.
  E_ASIENTO_DEL_CIERRE:
    'Ese asiento lo calculó el cierre de la jornada a partir del efectivo contado. Para corregirlo, reabrir la jornada y volver a cerrarla.',
  // Lo contrario de E_PERIODO_CERRADO, y por eso necesita su propio código: acá el problema no es
  // que el mes esté cerrado sino que TODAVÍA no lo está, así que la corrección correcta es anular
  // y no contrarrestar. Dos formas de corregir la misma cosa dejan dos rastros distintos del
  // mismo error.
  E_PERIODO_ABIERTO:
    'El periodo de ese asiento todavía está abierto. Corregirlo anulando el asiento, que deja el motivo al lado, en vez de registrar un contraasiento.',
  // Decía «el empleado». La fase 12 lo levanta también para un proveedor al que le falta alguno de
  // los tres datos de giro, y el código significa lo mismo en los dos casos: no hay con qué girar.
  // Un mensaje que nombra al empleado en la pantalla de proveedores no es un detalle de redacción,
  // es una frase que habla de otra persona.
  E_SIN_CUENTA_BANCARIA:
    'Faltan datos para girar: el banco, la clase de cuenta y el número van juntos.',
  E_SIN_AUTORIZACION_DESCUENTO: 'Falta la autorización escrita del empleado para descontarle de la nómina.',
  E_COMPRA_YA_VALIDADA: 'La compra ya estaba validada. Para cambiarla, corregirla.',
  E_COMPRAS_SIN_VALIDAR: 'Hay compras del periodo sin validar. Validarlas o rechazarlas antes de cerrar.',
  E_JORNADAS_SIN_CERRAR: 'Hay jornadas del periodo sin cerrar. Cerrarlas antes de cerrar el mes.',
  // Nace en la tarea 16 de la fase 5 y no reusa ninguno de los dos codigos que tenia
  // cerca. E_JORNADAS_SIN_CERRAR manda a cerrar la jornada, y el cierre normal la
  // rechaza desde la tarea 12: el camino es el re-cierre. Y
  // E_JORNADA_EN_CORRECCION_EXISTE esta escrito para quien intenta REABRIR una segunda
  // jornada, no para el contador que cierra el mes. Un codigo prestado es una pantalla
  // que dice lo que no es.
  E_JORNADA_SIN_RECERRAR:
    'Hay una jornada del periodo en corrección. Volver a cerrarla desde el recierre antes de cerrar el mes.',
  // Los tres entran con la tarea 7 de la fase 7, que es la primera pantalla que los puede
  // mostrar: el formulario de gasto. Están en el catálogo del maestro desde la tarea 1 y sin
  // frase, así que hasta acá quien los recibía leía el código crudo.
  //
  // `E_PROVEEDOR_REQUERIDO` NO ES `E_PROVEEDOR_NO_EXISTE`, y por eso son dos. El primero es
  // no haber elegido ninguno y la salida es abrir la lista; el segundo es haber elegido uno
  // que ya no está y la salida es refrescar el directorio. Con un solo código, la mitad de
  // los casos leería una instrucción que no aplica.
  E_PROVEEDOR_REQUERIDO:
    'Elegir un proveedor del directorio: los pagos por transferencia lo exigen.',
  // Adjudicación 274: lo pagado a un proveedor con retención es una factura, y la retención la
  // registra la oficina (feature 17).
  E_PROVEEDOR_CON_RETENCION:
    'A este proveedor se le practica retención: registrarlo como factura, con su número, para que la retención quede registrada.',
  // Adjudicación 280: cada impuesto va sobre una parte del subtotal.
  E_BASE_FUERA_DEL_SUBTOTAL: 'La base de un impuesto no puede ser negativa ni pasar del subtotal de la factura.',
  // Adjudicación 279: el concepto de retención llega de la lista de la base.
  E_CONCEPTO_RETENCION_NO_EXISTE: 'Ese concepto de retención no existe. Recargar la página y elegirlo de nuevo.',
  // Adjudicación 276: el borrado de lo anulado se deshace entero si fuera a tocar algo vivo.
  E_BORRADO_TOCA_LO_ACTIVO:
    'No se borró nada: el borrado iba a tocar registros vivos. Revisar que lo que se quiere borrar esté anulado.',
  E_RETENCION_DE_LA_OFICINA:
    'A este proveedor se le practica retención: su factura la paga la contadora.',
  // Cubre tres estados que para quien registra son el mismo: la categoría no existe, está
  // desactivada, o se fusionó en otra. En los tres la salida es la misma, elegir otra de la
  // lista, y el detalle del error dice cuál de los tres fue.
  E_CATEGORIA_INACTIVA: 'Esa categoría ya no está disponible. Elegir otra de la lista.',
  E_CATEGORIA_TIPO_INVALIDO:
    'Esa categoría no sirve para este registro: un egreso va en una de egreso y un ingreso en una de ingreso.',
  E_CATEGORIA_CON_MOVIMIENTOS: 'La categoría tiene movimientos. Desactivarla o reasignarlos a otra.',
  // Los dos de la tarea 13 de la fase 12. La restricción cuenta lo inactivo y lo fusionado, que la
  // lista de la pantalla no muestra, así que la frase lo dice: si no, quien lee «ya existe» busca
  // en la lista, no lo encuentra y cree que es un error.
  E_CATEGORIA_CODIGO_DUPLICADO:
    'Ya hay una categoría con ese código, aunque puede estar desactivada o fusionada. Usar otro código.',
  E_CATEGORIA_EQUIVALENTE:
    'Ya existe una categoría con ese nombre o con uno que significa lo mismo. Usar la que está.',
  E_ITEM_NOMBRE_DUPLICADO:
    'Ya hay un ítem con ese nombre en el catálogo, aunque puede estar inactivo. Usar otro nombre.',
  E_PROVEEDOR_CON_PAGOS: 'El proveedor tiene pagos registrados. Marcarlo como inactivo en vez de borrarlo.',
  // Los tres de los soportes del proveedor, fase 12 tarea 18, 2026-09-30.
  E_SOPORTE_NO_EXISTE: 'No se encontró el archivo del soporte. Volver a adjuntarlo.',
  E_PROVEEDOR_SIN_SOPORTES:
    'Para cambiar la cuenta bancaria adjuntar la certificación bancaria de la cuenta nueva.',
  E_PROVEEDOR_NO_PENDIENTE: 'Ese proveedor no está esperando autorización. Refrescar el directorio.',
  E_DOCUMENTO_DUPLICADO: 'Ya existe un registro con ese documento.',
  E_CONTEO_INVENTARIO_FALTANTE: 'Falta el conteo físico de inventario del periodo.',
  // Los seis de abajo entran con la tarea 27 de la fase 7, la de los adjuntos, y entran los
  // seis porque el plan de esa tarea levantaba `E_DOCUMENTO_DUPLICADO` en cinco guardas
  // distintas: el egreso que no existe, el tipo que no se acepta, el archivo muy grande, la
  // reserva que no existe y el adjunto ya confirmado. Ninguna de las cinco es un duplicado, y
  // con un solo código las cinco pantallas dirían "ya existe un registro con ese documento" a
  // quien acaba de elegir un .exe o una foto de 20 MB. Es la misma corrección de las tareas 18,
  // 21 y 24, cuarta vez en la misma fase.
  //
  // `E_ARCHIVO_VACIO` NO ES `E_ARCHIVO_EXCEDE_LIMITE`, aunque los dos hablen del tamaño: uno
  // manda a comprimir y el otro a volver a elegir el archivo, y son instrucciones opuestas.
  //
  // Y los nombres son EXACTAMENTE los que levanta la base. La capa de subida del plan lanzaba
  // `E_TIPO_NO_ACEPTADO` y `E_ARCHIVO_MUY_GRANDE` por su cuenta, dos códigos que no existen en
  // ningún catálogo: la misma rechazada leía un mensaje distinto según la hubiera visto el
  // navegador o el servidor, y el del navegador caía en `E_DESCONOCIDO`.
  E_EGRESO_NO_EXISTE: 'No existe ese egreso, o este rol no lo ve. Refrescar la lista de egresos.',
  E_TIPO_ARCHIVO_NO_ACEPTADO:
    'Ese archivo no sirve como soporte: se aceptan fotos JPEG, PNG o WebP y archivos PDF.',
  E_ARCHIVO_VACIO: 'El archivo llegó sin contenido. Volver a elegirlo o tomar la foto de nuevo.',
  E_ARCHIVO_EXCEDE_LIMITE:
    'El soporte no puede pasar de 8 MB. Tomar la foto de nuevo o elegir una más liviana.',
  E_ADJUNTO_NO_EXISTE:
    'No hay una reserva de adjunto con ese identificador. Volver a adjuntar el soporte.',
  E_ADJUNTO_YA_CONFIRMADO:
    'Ese soporte ya quedó adjunto y no se reemplaza. Adjuntar otro si hace falta.',
  // Entra con la tarea 30 de la fase 7, que es la primera pantalla que lo puede mostrar: el
  // formulario de cortesía. Está en el catálogo del maestro y en la hoja de contrato desde la
  // tarea 16, que es la que lo levanta, y hasta acá `esCodigoConocido` lo desconocía: el
  // rechazo del servidor llegaba a la pantalla convertido en `E_DESCONOCIDO`, o sea que la
  // única guarda del consumo del personal era ilegible justo del lado que la tiene que
  // explicar. Es la misma corrección de la tarea 27, y se encuentra igual: escribiendo la
  // pantalla que necesita la frase.
  E_CONSUMIDOR_REQUERIDO:
    'Un consumo del personal queda asociado al empleado que lo consumió. Elegirlo de la lista.',
  // Los seis de abajo entran con la tarea 31, el tablero de pagos, que es la primera pantalla que
  // los puede mostrar. Los seis están en el catálogo del maestro desde las tareas 15, 19, 21 y 23,
  // y ninguno tenía frase: `esCodigoConocido` los descartaba y los seis rechazos llegaban a la
  // contadora como `E_DESCONOCIDO`. Es la tercera vez que el catálogo del contrato y el diccionario
  // de la interfaz se encuentran desalineados al escribir la pantalla, después de las tareas 27
  // y 30, y las tres veces el hueco lo abrió la misma costumbre: el código se agrega donde se
  // levanta y la frase donde se lee, que son dos tareas distintas.
  //
  // `E_FACTURA_NO_EXISTE` NO ES `E_FACTURA_YA_PAGADA`. El primero es una lista vieja y la salida es
  // refrescarla; el segundo es que alguien más la pagó y la salida es no volver a pagarla. Con un
  // solo código, la mitad de los casos leería la instrucción contraria a la que necesita.
  E_FACTURA_NO_EXISTE: 'No existe esa factura. Refrescar el tablero de pagos.',
  E_FACTURA_YA_PAGADA:
    'Esa factura ya no está pendiente: alguien más la pagó o la anuló. Refrescar el tablero.',
  E_ABONO_EXCEDE_SALDO:
    'El abono es mayor que el saldo de la factura. Refrescar el tablero y corregir el valor.',
  // Se practica entera en el pago que cierra la factura, sobre el total del documento. Si ese pago
  // es más chico que la retención, la retención tenía que haberse practicado antes.
  E_RETENCION_EXCEDE_ABONO:
    'Las retenciones de esta factura suman más que el abono que la cierra. Revisar los pagos anteriores.',
  E_TARIFA_FUERA_DE_RANGO:
    'La tarifa es un porcentaje entre 0 y 100: 2,5 se escribe 2.5 y no 0.025. Corregir el perfil del proveedor.',
  E_VENCIMIENTO_INVALIDO: 'El día de vencimiento es un número del 1 al 31.',

  // Los cinco de la fase 8 entran con la MIGRACIÓN que los levanta, la tarea 4, y no con la
  // pantalla que los lee, que es la 18. Es lo contrario de lo que pasó con los seis de la tarea 31,
  // con `E_CONSUMIDOR_REQUERIDO` y con los seis de la 27, y el maestro ya anotó tres veces la misma
  // causa: el código se agrega donde se levanta y la frase donde se lee, que son dos tareas
  // distintas y a veces dos fases. La cuarta vez se corta agregando las dos mitades juntas, aunque
  // hoy solo una de las cinco frases tenga quien la muestre.
  E_ITEM_CON_MOVIMIENTOS:
    'Ese ítem tiene movimientos, compras, recetas o conteos: no se puede borrar. Marcarlo como inactivo para conservar su historial.',
  E_ITEM_INACTIVO: 'Ese ítem está inactivo: no acepta compras ni salidas. Reactivarlo primero.',
  // «Estado inválido» dicho con la salida y no con el nombre del estado: quien lee esto está
  // mirando una compra que ya cambió de manos, y lo que necesita saber es que refresque.
  E_COMPRA_ESTADO_INVALIDO:
    'Esa compra ya no está en el estado que esa acción necesita. Refrescar la bandeja y volver a mirarla.',
  E_COMPRA_CON_FACTURA:
    'Esa compra tiene su factura en Egresos: se paga con «Pagado» en la lista, y para deshacerla se anula la factura, que se lleva la compra.',
  E_EXCEDENTE_NO_CUADRA:
    'Los billetes tienen que sumar exactamente el excedente que el cierre pasó a la cajita esa noche. Volver a contarlos.',
  E_EXCEDENTE_YA_GUARDADO: 'El excedente de esa noche ya se guardó en la cajita.',
  E_JORNADA_NO_CERRADA: 'El excedente se guarda después de cerrar la noche.',
  // Las ventas de Umashi, adjudicación 300.
  E_FECHA_FUTURA: 'La fecha no puede ser futura. Elegir hoy o un día anterior.',
  E_DESCUENTO_MAYOR_AL_SUBTOTAL: 'El descuento no puede ser igual o mayor que el subtotal de la factura.',
  E_CLIENTE_REQUERIDO: 'Escribir el nombre del colaborador de La Clásica que hizo el pedido.',
  // Adjudicación 305: lo que no se deja al anular un pago de propinas.
  E_CONTRAASIENTO_DE_PROPINAS: 'El contraasiento de un pago de propinas no se anula. Para corregirlo, repartir otra vez.',
  E_PAGO_YA_CONCILIADO: 'Ese pago ya está conciliado con el extracto del banco. Desconciliarlo antes de anularlo.',
  E_VENTA_YA_CRUZADA: 'Esa venta ya se descontó de las propinas del colaborador, así que no se puede anular.',
  E_COMPRA_NO_CUADRA_CON_FACTURA:
    'Los productos de la compra tienen que sumar el subtotal de su factura. Si la factura estaba mal, anularla y registrar la compra de nuevo.',
  E_CATEGORIA_NO_ES_DE_COMPRA:
    'Una compra de inventario va a una categoría de costo de ventas, como Insumos de cocina o Licores y bebidas. Elegir una de esas.',
  E_CANTIDAD_NO_POSITIVA: 'La cantidad tiene que ser mayor que cero.',
  E_LINEA_DUPLICADA:
    'Ese ítem ya está en el documento. Sumar las dos cantidades en una sola línea, para que cuadre contra la factura de papel.',
  // LOS DOS DE LA TAREA 6, y los dos salieron de la convención del propio catálogo. El bloque
  // usaba `E_ITEM_INACTIVO` para «el ítem no existe», que son dos cosas distintas y se corrigen
  // distinto: «no existe» se arregla buscando otro y «está inactivo» se arregla reactivándolo. Hay
  // once códigos con la forma `E_<COSA>_NO_EXISTE` y ninguno era de ítem.
  E_ITEM_NO_EXISTE: 'No existe ese ítem. Refrescar el catálogo.',
  // Con la forma de `E_MOTIVO_REQUERIDO` y `E_PROVEEDOR_REQUERIDO`: falta un dato obligatorio, y
  // la frase dice para qué sirve, porque el administrador que no puso unidad no está pensando en
  // el inventario sino en el nombre del producto.
  E_UNIDAD_REQUERIDA:
    'Falta la unidad en la que se compra y se cuenta ese ítem, como botella o paquete. Sin ella no se puede comprar ni contar.',
  // El de la tarea 7, por la misma razón que `E_ITEM_NO_EXISTE`: el bloque usaba
  // `E_COMPRA_ESTADO_INVALIDO` también para la compra que no existe, y son dos remedios distintos.
  // «Cambió de estado» se arregla mirándola de nuevo; «no existe» se arregla dejando de buscarla.
  E_COMPRA_NO_EXISTE: 'Esa compra ya no está. Refrescar la bandeja.',
  // El de la tarea 14, y sale de que `E_CANTIDAD_NO_POSITIVA` dice «tiene que ser mayor que cero»
  // y en un conteo físico **el cero es válido**: contar cero botellas de vodka es un dato, y
  // además es el que genera el ajuste más grande. La regla real de
  // `conteo_inventario_linea_contado_ck` es que no sea negativa, y con el código de al lado la
  // pantalla le habría dicho al operario que corrigiera un cero que estaba bien.
  E_CANTIDAD_NEGATIVA: 'La cantidad no puede ser negativa. El cero sí vale: es lo que se contó.',

  // LOS QUINCE MUDOS, Y ESTA VEZ SE MIDIÓ EN VEZ DE NOTARLO. El comentario de los cinco de la
  // fase 8, doce entradas más arriba, dice que iba a ser «la cuarta vez que se corta agregando
  // las dos mitades juntas». No se cortó: el 2026-09-14, construyendo la tarea 5 de la fase 9, se
  // contaron los códigos de los `raise exception` de `supabase/migrations` contra las claves de
  // este objeto y salieron **94 levantados contra 84 traducidos**. Estos quince llegaban a la
  // pantalla como «Ocurrió un error que la aplicación no reconoce» con el código crudo al lado,
  // algunos desde la fase 0.
  //
  // ONCE DE LOS QUINCE YA ESTABAN EN LA TABLA DE CONTRATO del plan maestro, así que no eran
  // códigos inventados: lo que faltaba era su frase. Los otros cuatro son los dos del saldo de
  // apertura y los dos que la fase 9 agregó en sus tareas 1 y 3.
  //
  // La diferencia con las cuatro veces anteriores no es que se hayan agregado, es que la cuenta
  // ahora se puede repetir en dos comandos y queda pendiente como noveno verificador. Una regla
  // que vale para todos los códigos se afirma sobre el catálogo, que es la adjudicación 56.

  // Los de cargo y empleado, de la fase 3. `NO_EXISTE` y `NO_ACTIVO` son dos remedios distintos,
  // como `E_ITEM_NO_EXISTE` y `E_ITEM_INACTIVO` doce líneas más arriba.
  E_CARGO_NO_EXISTE: 'No existe ese cargo o está inactivo. Elegir otro de la lista de cargos.',
  E_EMPLEADO_NO_EXISTE: 'No existe ese empleado. Refrescar la lista y volver a elegirlo.',
  E_EMPLEADO_NO_ACTIVO:
    'Ese empleado está inactivo: no entra al reparto de propinas ni a la nómina. Reactivarlo primero.',

  // Los del reparto de propinas, de la fase 3. Los tres de estado dicen en qué estado está y cuál
  // es el paso que falta, porque «estado inválido» a secas obliga a adivinar cuál era el bueno.
  E_REGLA_NO_EXISTE: 'No existe esa regla de reparto o está inactiva. Elegir otra de la lista.',
  E_REPARTO_NO_EXISTE: 'No existe ese reparto de propinas. Refrescar la noche y volver a mirarlo.',
  E_REPARTO_YA_CONFIRMADO:
    'Ese reparto ya está confirmado, y solo se confirma uno recién calculado. Si hay que cambiarlo, volver a calcularlo.',
  E_REPARTO_NO_CONFIRMADO:
    'Ese reparto todavía no está confirmado, y solo se paga uno confirmado. Confirmarlo antes de pagarlo.',
  E_REPARTO_YA_PAGADO:
    'Ese reparto ya se pagó y no se paga dos veces. Si el pago estaba mal, anular el asiento del pago.',
  E_REPARTO_MEDIO_INVALIDO:
    'Ese reparto se calculó para otro medio de pago y se paga por el mismo con el que se calculó.',

  // Los del gasto recurrente, de la fase 7.
  E_OCURRENCIA_NO_EXISTE:
    'No existe esa ocurrencia del gasto recurrente. Refrescar el mes y volver a mirarla.',
  E_OCURRENCIA_YA_PAGADA:
    'Esa ocurrencia ya está pagada y no se paga dos veces. Si el pago estaba mal, anularlo.',

  // El de las categorías, de la fase 7: reclasificar no borra, agrega la versión siguiente.
  E_CLASIFICACION_INMUTABLE:
    'Una clasificación que ya se usó no se borra ni se edita: reclasificar agregando la versión siguiente.',

  // El de la fase 9, tarea 1. La fecha que decide es la CONTABLE del periodo liquidado, así que la
  // frase no dice «hoy»: dice «esa fecha», que es lo que el usuario eligió.
  E_PARAMETRO_LABORAL_FALTANTE:
    'Falta el parámetro laboral con vigencia para esa fecha. Cargarlo antes de liquidar la nómina.',

  // El de la fase 9, tarea 9. El remedio es anular el ASIENTO, y la frase lo dice así porque es
  // literalmente el único camino: las tres tablas del snapshot son de solo inserción, y anular el
  // asiento es lo que hace que `app.tg_nomina_sigue_asiento` libere el índice único parcial del
  // periodo. Una frase que dijera «borrala y volvé a empezar» mandaría a una puerta cerrada.
  E_NOMINA_YA_LIQUIDADA:
    'Ese mes ya tiene una liquidación de nómina activa. Anular su asiento antes de volver a liquidarlo.',

  // Los dos de la fase 9, tarea 11. `YA_PAGADA` es un código propio y no una reutilización de
  // `YA_LIQUIDADA`, y la diferencia no es de vocabulario: liquidar y pagar son dos hechos con dos
  // remedios distintos, así que reusar el código mandaría a quien pagó dos veces a anular el
  // asiento de la liquidación, que es lo contrario de lo que necesita. Es la adjudicación 227 vista
  // al revés: allá se inventaba una segunda ortografía de un concepto que ya existía, acá se
  // reutilizaba un código existente para un concepto distinto.
  // La frase nació en la tarea 11 diciendo «liquidá el mes antes de pagarlo», y la tarea 12 la
  // corrige porque levanta el mismo código desde el desprendible, donde hablar de pagar manda al
  // lado equivocado. Es lo mismo que esta fase le reprochó al bloque de la tarea 11 con
  // `E_NOMINA_YA_LIQUIDADA`: un código que sirve a dos usos necesita una frase que sirva a los dos,
  // o dos códigos. Acá el concepto sí es uno solo, «esa liquidación no está», así que la frase se
  // vuelve neutral en el remedio en vez de partir el código.
  E_NOMINA_NO_LIQUIDADA:
    'Esa liquidación de nómina no existe o fue anulada. Revisar el periodo y liquidarlo si hace falta.',
  E_NOMINA_YA_PAGADA:
    'Esa liquidación ya tiene su pago registrado y no se paga dos veces. Si el pago estaba mal, anular su asiento.',

  // Los dos del saldo de apertura, de la fase 0. Son los más viejos de esta lista y los que más
  // tiempo llevaban mudos.
  E_SALDO_APERTURA_YA_CARGADO:
    'El saldo de apertura ya se cargó una vez y no se vuelve a cargar. Si estaba mal, corregirlo con un ajuste.',
  E_SALDO_APERTURA_VACIO:
    'No llegó ningún saldo para cargar. Revisar el archivo de apertura y volver a enviarlo.',

  // ---------------------------------------------------------------------------------------------
  // LOS TRECE MUDOS DEL 2026-09-18, Y ESTA VEZ LOS ENCONTRÓ UN SCRIPT
  // ---------------------------------------------------------------------------------------------
  // Es la cuarta vez que esta lista se queda corta. Las tres anteriores se contaron a mano; esta la
  // midió `scripts/verificar-errores.mjs`, escrito el mismo día, y el resultado es el de siempre:
  // **se buscaban tres y había trece.** Los tres eran los de socios, que el HANDOFF anotaba. Los
  // nueve de la conciliación bancaria no los echaba de menos nadie porque sus pantallas todavía no
  // existen, y ese es justo el punto: habrían llegado mudas el día que se escribieran. El trece lo
  // introdujo la tarea 12 de la fase 11, dos días antes, en el mismo commit que decía cuidar esto.
  //
  // El verificador queda corriendo con los otros ocho, así que la quinta vez no va a existir.

  // Los tres de socios, de la fase 10. `no existe` y `está inactivo` se separan porque se corrigen
  // distinto: uno se arregla buscando otro socio y el otro reactivándolo.
  E_SOCIO_NO_EXISTE: 'No existe ese socio. Refrescar la lista y volver a elegirlo.',
  E_SOCIO_INACTIVO:
    'Ese socio está inactivo, así que no registra aportes ni retiros. Reactivarlo antes de seguir.',
  // NO DICE «no se puede». El retiro sí se puede hacer: la función lo deja pasar cuando quien lo
  // ordena confirma que sabe. La frase tiene que decir qué se está aceptando, no negar algo que el
  // botón de al lado permite, o el administrador lo lee como un defecto de la aplicación.
  E_RETIRO_COMPROMETE_OPERACION:
    'Con ese retiro no alcanza para los compromisos del mes. Mirar las cifras y confirmar si aun así se quiere hacer.',

  // Los nueve de la conciliación bancaria, de la fase 10, features 22. Sus pantallas son las tareas
  // 19 y 20, así que estas frases llegan antes que la primera pantalla que las va a mostrar.
  E_CUENTA_NO_BANCARIA:
    'Esa cuenta no es una cuenta de banco, así que no tiene extracto que conciliar. Elegir la cuenta bancaria.',
  E_EXTRACTO_NO_EXISTE: 'No existe ese extracto. Refrescar la lista y volver a elegirlo.',
  E_EXTRACTO_DUPLICADO:
    'Ese archivo ya se cargó para esa cuenta. Si el banco lo reemplazó, cargar el archivo nuevo con su nombre.',
  E_EXTRACTO_FORMATO_INVALIDO:
    'Al extracto le faltan datos: necesita el periodo con inicio y fin en orden, el nombre del archivo y sus líneas. Revisar el archivo del banco.',
  E_LINEA_YA_CONCILIADA:
    'Esa línea del extracto ya está emparejada con un movimiento. Deshacer el emparejamiento antes de cambiarlo.',
  E_MOVIMIENTO_NO_EXISTE: 'Ese movimiento ya no está. Refrescar el extracto y volver a mirarlo.',
  // Dice POR QUÉ no es conciliable, que es lo único que permite entender la pantalla: un movimiento
  // anulado no está en el saldo, así que emparejarlo dejaría el extracto cuadrando contra plata que
  // el libro ya no cuenta.
  E_MOVIMIENTO_NO_CONCILIABLE:
    'Ese movimiento está anulado, así que ya no está en el saldo que el extracto confirma. Buscar el movimiento vigente.',
  E_CONCILIACION_MONTO_DISTINTO:
    'La línea del extracto y el movimiento son por montos distintos. El emparejamiento manual no admite diferencias: registrar el ajuste que las explique.',
  // De la fase 0, y llevaba mudo desde entonces. La frase no habla de la carga del saldo inicial en
  // abstracto: dice la fecha que no se puede pasar, que es lo que el usuario tiene que corregir.
  E_FECHA_ANTERIOR_A_APERTURA:
    'Esa fecha es anterior a la carga del saldo inicial, y antes de esa fecha el libro no existe. Usar una fecha posterior.',

  // El de la fase 11, tarea 12.
  E_CATEGORIA_NO_EXISTE: 'No existe esa categoría. Refrescar la lista y volver a elegirla.',
} as const satisfies Record<string, string>;

export type CodigoError = keyof typeof MENSAJES;

export const CODIGOS_ERROR = Object.keys(MENSAJES) as readonly CodigoError[];

export function esCodigoConocido(codigo: string): codigo is CodigoError {
  return Object.hasOwn(MENSAJES, codigo);
}

/**
 * Traduce a español el error que devolvió la base de datos.
 *
 * Acepta el código solo o un mensaje completo del que lo extrae, porque Postgres
 * devuelve el código seguido de dos puntos y el detalle.
 */
export function traducirError(entrada: string): string {
  // Esta función existe para que la interfaz nunca se quede sin mensaje, así que no
  // puede reventar justo cuando algo ya salió mal. `error?.message` es `undefined`
  // cada vez que lo que se atrapó no es un Error, que es lo normal en una falla de
  // red, y ahí `.split` tiraba un TypeError crudo encima del error original.
  if (typeof entrada !== 'string') {
    return 'Ocurrió un error que la aplicación no reconoce. Avisar al administrador.';
  }
  const codigo = entrada.split(':', 1)[0]?.trim() ?? entrada;
  if (esCodigoConocido(codigo)) return MENSAJES[codigo];
  return `Ocurrió un error que la aplicación no reconoce. Avisar al administrador con el código ${codigo}.`;
}
